module.exports = {
  publicPath: '/beauties_shindan/',
  assetsDir: '',
  pages: {
    index: {
      // 最初に実行されるファイル名
      entry: 'src/main.js',
      // テンプレートファイル
      template: 'public/index.html',
      // 出力されるファイル名
      filename: 'index.html',
      // タイトルの設定
      // <title><%= htmlWebpackPlugin.options.title %></title>
      title: 'あなたはどのタイプ？ BEAUTIES診断',
      description: '最近よく聞くＳＤＧｓ、私にも何かできることは？そんなあなたへ。人や環境にやさしく、自分もキレイになれるなら、お買い物はもっと楽しくて、うれしい。いつものお買い物で未来を変える。EARTH MALL BEAUTIESが提案する５人のBEAUTIESから、あなたらしいサステナブルビューティーを見つけてみませんか。'
    }//,
    // サブページをせっているするとエントリーページのファイル以外はこちらが参照される。
    // テンプレートファイルは、 `public/subpage.html`
    // public/subpage.htmlがなかったら `public/index.html`が呼び出される。
    // 出力されるファイル名は `subpage.html`となる。
    // subpage: 'src/subpage/main.js'
  },
  // キャッシュバスティングのためにファイル名にハッシュをつけている。
  // デフォルトでtrueなので、falseの場合のみ指定
  filenameHashing: false,
  // ポートなどの設定
  devServer: {
    // port: 5000,
    // contentBase: path.resolve(__dirname, 'public'),
    // host: 'localhost',
  },
  css: {
    // 毎回読み込んでおくscssファイルの指定
    loaderOptions: {
      sass: {
        // data: `@import "@/val.scss";`
      }
    }
  },
  configureWebpack: {
    module: {
      rules: [
        {
          // test: /\.js$/,
          // loader: 'babel-loader',
          // exclude: /node_modules/,
        }
      ]
    },
    resolve: {
      alias: {
        // 'vue$': 'vue/dist/vue.esm.js',
        // '@': path.resolve(__dirname, 'src/'),
      }
    },
    plugins: [
      // plugin
    ]
  }
}
